<template>
  <div :class="[`stars-${value}`]" :title="title" style="font-size: 21px">
    <i
      :class="`icon-star ${otherClasses(1)}`"
      style="font-size: 21px"
      @click="!disabled && emitValue(1)"
      @mouseover="setValueHovered(1)"
      @mouseout="setValueHovered(0)"
    ></i>
    <i
      :class="`icon-star ${otherClasses(2)}`"
      @click="!disabled && emitValue(2)"
      @mouseover="setValueHovered(2)"
      @mouseout="setValueHovered(0)"
      ><i class="icon-star-half"></i
    ></i>
    <i
      :class="`icon-star ${otherClasses(3)}`"
      @click="!disabled && emitValue(3)"
      @mouseover="setValueHovered(3)"
      @mouseout="setValueHovered(0)"
      ><i class="icon-star-half"></i
    ></i>
    <i
      :class="`icon-star ${otherClasses(4)}`"
      @click="!disabled && emitValue(4)"
      @mouseover="setValueHovered(4)"
      @mouseout="setValueHovered(0)"
      ><i class="icon-star-half"></i
    ></i>
    <i
      :class="`icon-star ${otherClasses(5)}`"
      @click="!disabled && emitValue(5)"
      @mouseover="setValueHovered(5)"
      @mouseout="setValueHovered(0)"
    ></i>
  </div>
</template>

<script>
export default {
  name: 'StarsInput',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change'],
  data() {
    return {
      valueHovered: 0,
    }
  },
  methods: {
    otherClasses(starIndex) {
      return `${!this.disabled ? 'pointer' : ''} ${
        starIndex <= this.valueHovered ? 'hovered' : ''
      }`
    },
    emitValue(v) {
      this.$emit('change', v)
    },
    setValueHovered(v) {
      this.valueHovered = v
    },
  },
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.pointer.hovered {
  color: #160c0a;
}
</style>
